import { Navigate, Route, Routes } from 'react-router';

import { useCurrentSession } from '@/services/auth';
import useViewport from '@/utils/useViewport';

import { Account } from './Account/Account';
import { Organization } from './Organization/Organization';
import { SettingsMobileMenu } from './SettingsMobileMenu/SettingsMobileMenu';
import { SettingsOrganization } from './SettingsOrganization/SettingsOrganization';
import { Organizations } from './Support/Organizations';
import { Tools } from './Support/Tools';
import { SettingsContext, useSettingsOrganizationScope } from './SettingsContext';

export const Settings = () => {
  const { currentSession } = useCurrentSession();
  const organizationScope = useSettingsOrganizationScope();
  const { isMobile } = useViewport();

  if (!currentSession?.isSupport) {
    return <Navigate to="/" replace />;
  }

  return (
    <SettingsContext value={{ scope: organizationScope }}>
      <Routes>
        <Route
          path=""
          element={
            isMobile ? <SettingsMobileMenu /> : <Navigate to="/settings_beta/account" replace />
          }
        />
        <Route path="account/*" element={<Account />} />
        <Route path="organization" element={<Organization />} />
        <Route path="support/organizations" element={<Organizations />} />
        <Route path="support/tools/*" element={<Tools />} />
        <Route
          path="support/*"
          element={<Navigate to="/settings_beta/support/organizations" replace />}
        />
        <Route
          path="*"
          element={
            organizationScope ? (
              <SettingsOrganization key={organizationScope.organizationId} />
            ) : (
              <Navigate to="/settings_beta/account" replace />
            )
          }
        />
      </Routes>
    </SettingsContext>
  );
};
